/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
class Product extends Core {
	constructor() {
		super();
		this.initializeElements();
		this.selectedVariant = null;
		this.vaseAddOn = null;
		this.productType = document.querySelector("[data-product-type]").dataset.productType;
		this.productId = document.querySelector("form[data-product-id]").dataset.productId;
		this.selectedOptions = {};
		this.showCardsFor = ["bouquet", "letterbox", "plant"];

		this.giftBuilder = new GiftBuilder();
	}

	initializeElements() {
		this.loadingEl = document.getElementById("loading-state");
		this.variantsForm = document.getElementById("variant-selector");
		this.variantInputs = Array.from(document.querySelectorAll('#variant-selector input[name="variant"]'));
		this.variantOptionsForm = document.getElementById("variant-options-form");
		this.productMediaContainer = document.getElementById("product-media-container");
		this.productMediaContainerCarousel = document.querySelector("#product-media-container-carousel [data-movable]");
		this.variantElements = Array.from(document.querySelectorAll("[data-variant]")); // stuff to show when variant is selected (addons..)
		this.variants = Array.from(document.querySelectorAll('input[name="variant"]'));
		this.addToBagBtn = document.getElementById("add-to-bag");
		this.backToStockContainer = document.querySelector("[data-back-in-stock]");
		this.giftVoucherFormContainer = document.getElementById("form-gift-voucher");
		this.firstGroupVarNumber = Array.from(this.variantOptionsForm.querySelectorAll("ul li:first-child ul li")).length;
		this.numberOFVariants = Array.from(this.variantOptionsForm.querySelectorAll("ul li ul li")).length;
	}

	init() {
		// Add event listeners to option inputs
		const optionInputs = Array.from(this.variantOptionsForm.querySelectorAll('input[type="radio"]'));
		optionInputs.forEach((optionInput) => {
			optionInput.addEventListener("change", this.handleOptionChange.bind(this));
		});
		// Initially hide all option groups except the first one (Size)
		this.initializeOptionGroups();

		this.handleProductMediaContainer();
		this.handleVaseAddOn();
		this.addToBagBtn?.addEventListener("click", this.startGiftBuilder.bind(this));
		this.checkSelectedVariantUrlParams();

		if (this.firstGroupVarNumber === 1) {
			// Selects first option if it's the only option
			const group = this.variantOptionsForm.querySelector("li[data-group-name]");
			const option = group.querySelector("li");
			this.autoSelectFirstAvailable(group);
			if (option && option.getAttribute("data-value") === "Default Title") {
				group.classList.add("hidden");
			}
		}
	}

	setupGiftVoucherForm(show) {
		if (!this.giftVoucherFormContainer) return;

		this.giftVoucherFormContainer.classList.toggle("hidden", !show);
		const sendAsGiftCb = this.giftVoucherFormContainer.querySelector("#send_as_gift");
		const giftFields = this.giftVoucherFormContainer.querySelector(".gift-fields");
		const giftEmailField = this.giftVoucherFormContainer.querySelector("#recipient_email");
		sendAsGiftCb.addEventListener("change", () => {
			giftFields.classList.toggle("hidden", !sendAsGiftCb.checked);
		});
		giftEmailField.addEventListener("click", () => {
			const gitfEmailEl = this.giftVoucherFormContainer.querySelector(".recipient-email");
			gitfEmailEl.classList.remove("border-warning");
		});
	}

	// [START] Variant select functions

	initializeOptionGroups() {
		const optionGroups = this.variantOptionsForm.querySelectorAll("li[data-group-name]");
		optionGroups.forEach((group, index) => {
			this.updateAvailableOptions(group); // check if has at least one sub option available
			if (index !== 0) {
				const groupItems = group.querySelector("ul");
				groupItems.setAttribute("hidden", "hidden"); // Hide all groups except the first
			}
		});
	}

	// Handle option change
	handleOptionChange(event) {
		const optionName = event.target.getAttribute("data-option-name");
		const optionValue = event.target.value;

		// Add selected option value next to option title when needed
		this.addOptionValueToOptionTitle(optionName, optionValue);

		// Update the selected options
		this.selectedOptions[optionName] = optionValue;

		// Reset and update lower levels after changing the higher-level option
		this.resetLowerOptions(optionName);

		// Show the next group of options based on current selection
		this.showNextOptionGroup();

		// Try to match a variant
		this.matchVariant();
	}

	// Reset lower-level options when higher-level option changes
	resetLowerOptions(changedOptionName) {
		let foundChangedOption = false;
		const optionGroups = this.variantOptionsForm.querySelectorAll("li[data-group-name]");

		// Iterate through each group to reset lower levels
		optionGroups.forEach((group) => {
			const groupName = group.getAttribute("data-group-name");

			if (groupName === changedOptionName) {
				foundChangedOption = true;
			}

			if (foundChangedOption && groupName !== changedOptionName) {
				// Clear the selection for lower-level groups
				this.selectedOptions[groupName] = undefined;
				const groupInputs = group.querySelectorAll('input[type="radio"]');
				groupInputs.forEach((input) => {
					input.checked = false;
				});
			}
		});
	}

	// Show the next option group based on selected options
	showNextOptionGroup() {
		const optionGroups = this.variantOptionsForm.querySelectorAll("li[data-group-name]");
		let showNext = true;

		optionGroups.forEach((group) => {
			const groupName = group.getAttribute("data-group-name");
			const groupItems = group.querySelector("ul");
			if (this.selectedOptions[groupName] !== undefined) {
				groupItems.removeAttribute("hidden"); // Keep current level visible if selected
			} else if (showNext) {
				groupItems.removeAttribute("hidden"); // Show next unselected level
				this.updateAvailableOptions(group); // Update options in the next group based on previous selections
				this.autoSelectFirstAvailable(group); // Auto-select the first available option in the next level
				showNext = false; // Stop after showing the next available level
			} else {
				groupItems.setAttribute("hidden", "hidden"); // Hide future levels until this one is selected
			}
		});
	}

	// Update available options in the group based on current selection
	updateAvailableOptions(group) {
		const groupName = group.getAttribute("data-group-name");
		const optionItems = group.querySelectorAll("li[data-option]");
		optionItems.forEach((item) => {
			const { value } = item.dataset;
			const inputField = item.querySelector("input");
			// Determine if the option is available based on previous selections
			const isAvailable = this.isOptionAvailable({ ...this.selectedOptions, [groupName]: value });
			if (!isAvailable) {
				item.style.display = "none"; // hide if not exist for the previously selected group option
			} else if (!isAvailable.hasAvailable) {
				item.style.display = "block";
				inputField.setAttribute("data-out-of-stock", "true");
			} else {
				item.style.display = "block";
				inputField.removeAttribute("data-out-of-stock");
			}
		});
	}

	// Automatically select the first available option in the group
	autoSelectFirstAvailable(group) {
		const availableOptions = group.querySelectorAll(
			'li[data-option]:not([style*="display: none"]) input[type="radio"]'
		);

		if (availableOptions.length > 0) {
			availableOptions[0].checked = true; // Automatically select the first available option
			const optionName = availableOptions[0].getAttribute("data-option-name");
			const optionValue = availableOptions[0].value;

			// Update the selected options for the auto-selected value
			this.selectedOptions[optionName] = optionValue;
			this.addOptionValueToOptionTitle(optionName, optionValue);
			// Reset and update lower levels after changing the higher-level option
			this.resetLowerOptions(optionName);
			// Show the next group of options based on current selection
			this.showNextOptionGroup();
			this.matchVariant();
		}
	}

	addOptionValueToOptionTitle(optionName, optionValue) {
		const optionGroups = Array.from(this.variantOptionsForm.querySelectorAll("li[data-group-name]"));
		const optGroup = optionGroups.find((group) => group.getAttribute("data-group-name") === optionName);
		if (!optGroup) return;
		const shouldReplace = optGroup.querySelector("[data-group-replace]");
		if (!shouldReplace) return;
		const replaceValue = shouldReplace.getAttribute("data-group-replace");
		// true: replace with option value, false: don't replace, other: use other
		if (!replaceValue || replaceValue === "false") return;
		shouldReplace.innerText = replaceValue === "true" ? optionValue : replaceValue;
	}

	// prepare and get available variantes from form 2 (control form)
	getAvailableVariants() {
		const optionInputs = Array.from(this.variantInputs);
		return optionInputs.map((opt) => ({
			id: opt.value,
			available: opt.dataset.variantAvailable === "true",
			optionSelected: JSON.parse(opt.dataset.variantSelectedOptions),
		}));
	}

	// Check if option is available for some previously selected option
	isOptionAvailable(params = {}) {
		const variantOptions = this.getAvailableVariants();
		const result = variantOptions.filter((variant) =>
			Object.entries(params).every(([paramName, paramValue]) =>
				variant.optionSelected.some((option) => option.name === paramName && option.value === paramValue)
			)
		);

		if (result.length === 0) return false;

		const hasAvailable = result.some((res) => res.available);
		return { hasAvailable };
	}

	checkInputSelected() {
		this.variantInputs.forEach((variantInput) => {
			if (this.selectedVariant && variantInput.value === this.selectedVariant.merchandiseId) {
				variantInput.checked = true;
			} else {
				variantInput.checked = false;
			}
		});
	}

	// Match the selected options with a variant in form 2 (control form)
	matchVariant() {
		this.selectedVariant = null; // Reset previously selected variant

		this.variantInputs.forEach((variantInput) => {
			const variantOptions = JSON.parse(variantInput.getAttribute("data-variant-selected-options"));

			const allOptionsMatch =
				variantOptions.length === Object.keys(this.selectedOptions).length &&
				Object.keys(this.selectedOptions).every((optionName) =>
					variantOptions.some(
						(option) => option.name === optionName && option.value === this.selectedOptions[optionName]
					)
				);
			if (allOptionsMatch) {
				// we have a variant selected
				const available = variantInput.getAttribute("data-variant-available");
				const price = variantInput.getAttribute("data-price");
				// Assign matching variant value
				this.selectedVariant = {
					merchandiseId: variantInput.value,
					price: parseFloat(price),
					available: available === "true",
				};
				this.vaseAddOn = null; // Clean variant related addons
				if (available === "true") {
					this.matchVariantAvailableActions();
				} else {
					this.matchVariantOOSActions();
				}
			}
		});
	}

	matchVariantAvailableActions() {
		this.addToBagBtn?.removeAttribute("disabled");
		this.displayVariantRelatedElements();
		this.checkInputSelected();
		this.setupGiftVoucherForm(true);
	}

	matchVariantOOSActions() {
		this.addToBagBtn?.setAttribute("disabled", "disabled");
		this.displayVariantRelatedElements();
		this.checkInputSelected();
		this.setupGiftVoucherForm(false);
		console.log("Variant out of stock");
	}

	// select variant using query params
	checkSelectedVariantUrlParams() {
		const params = new URL(document.location).searchParams;
		if (params.size === 0) return;

		const variantSku = params.get("v");
		if (!variantSku) return;

		const variantMatchInput = Array.from(this.variantInputs).find(
			(variant) => variant.getAttribute("data-sku").toUpperCase() === variantSku.trim().toUpperCase()
		);

		if (!variantMatchInput) return;
		const selectedOptions = JSON.parse(variantMatchInput.getAttribute("data-variant-selected-options"));

		const optionInputs = Array.from(this.variantOptionsForm.querySelectorAll('input[type="radio"]'));

		selectedOptions.forEach((opt) => {
			this.selectedOptions[opt.name] = opt.value;
			this.addOptionValueToOptionTitle(opt.name, opt.value);
			this.resetLowerOptions(opt.name);
			const optionButton = optionInputs.find(
				(input) => input.getAttribute("data-option-name") === opt.name && input.value === opt.value
			);
			if (optionButton) optionButton.setAttribute("checked", true);
		});

		this.showNextOptionGroup();
		this.matchVariant();
	}

	// [END] variant select functions

	// [START] Submit functions

	preparePayload(giftBuilderItems) {
		// Get gift recipeint details (Only for gift cards)
		const giftProperties = this.getGiftProperties();
		if (giftProperties && !giftProperties.find((item) => item.key === "Recipient email")) {
			const gitfEmailEl = this.giftVoucherFormContainer.querySelector(".recipient-email");
			gitfEmailEl.classList.add("border-warning");
			return false;
		}

		// Main product
		const items = [
			{
				merchandiseId: this.selectedVariant.merchandiseId,
				quantity: 1,
				...(giftProperties && { attributes: giftProperties }),
			},
		];

		// Gift builder response
		if (giftBuilderItems) items.push(...giftBuilderItems);

		return {
			site: this.siteId,
			...(window.cart.cartId && { cartId: window.cart.cartId }),
			items,
		};
	}

	getGiftProperties() {
		if (!this.giftVoucherFormContainer) return false;
		const sendAsGiftCb = this.giftVoucherFormContainer.querySelector("#send_as_gift");
		if (!sendAsGiftCb.checked) return false;

		const fields = Array.from(this.giftVoucherFormContainer.querySelectorAll(["input", "textarea"]));
		const fieldMap = {
			send_as_gift: "__shopify_send_gift_card_to_recipient",
			recipient_email: "Recipient email",
			recipient_name: "Recipient name",
			message: "Message",
			send_on: "Send on",
		};

		const attributes = [
			{
				key: "__shopify_offset",
				value: "0",
			},
		];

		attributes.push(
			...fields
				.filter((field) => field.value !== "")
				.map((field) => ({ key: fieldMap[field.name], value: field.value }))
		);

		return attributes;
	}

	giftBuilderVaseStep() {
		// If the customer has not selected an add-on (vase), it will be offered again in the gift builder.
		// it Will Check if vase was selected, if not prepare the step object

		const addOns = Array.from(document.querySelectorAll("[data-adds-container]"));
		const variantAddOns = addOns.find((a) => a.getAttribute("data-variant") === this.selectedVariant.merchandiseId);
		if (!variantAddOns) return false;

		let hasVaseSelected = false;
		const vaseItems = Array.from(variantAddOns.querySelectorAll("button[data-add-on]"));

		const items = vaseItems.map((i) => {
			if (i.hasAttribute("data-selected")) {
				hasVaseSelected = true;
			}

			const imgEl = i.querySelector("img");
			const titleEl = i.parentNode.querySelector("div p");
			const data = {
				id: i.getAttribute("data-add-on"),
				title: titleEl.innerText,
				available: i.getAttribute("data-available") === "true",
				productType: i.getAttribute("data-type"),
				image: { alt: imgEl.alt, url: imgEl.src },
				price: i.getAttribute("data-price"),
				sku: i.getAttribute("data-sku"),
			};

			return data;
		});

		return { hide: hasVaseSelected, items };
	}

	checkCartHealth(productTypes, showNErros = Infinity) {
		const isValid = window.arena.isValidCart(productTypes);
		if (!isValid.valid) {
			let message = "";
			if (isValid.reasons.length > 1 && showNErros > 1) {
				const uniqueErros = new Set(isValid.reasons.map((m) => m.pdpMessage));
				const errors = Array.from(uniqueErros)
					.splice(0, showNErros)
					.map((r) => `<li>${r}</li>`);
				message = `<ul class="list-disc list-inside">${errors.join("")}</ul>`;
			} else {
				message = isValid.reasons[0].pdpMessage;
			}

			return { valid: false, errors: message };
		}

		return { valid: true };
	}

	async startGiftBuilder() {
		if (!this.selectedVariant) return;
		const productType = this.productType.toLowerCase();

		// If current cart is not valid, open cart and show errors
		const currentCartHealth = this.checkCartHealth();
		if (!currentCartHealth.valid) {
			window.arena.showErrorMessage("Please review your cart", currentCartHealth.errors, true);
			return;
		}

		// Get the current cart content types/quantities, add the new proposed item then check the rules
		const proposedCart = window.arena.getProductTypeCounts();
		proposedCart[productType] = (proposedCart[productType] || 0) + 1;

		const proposedCartHealth = this.checkCartHealth(proposedCart, 1);
		if (!proposedCartHealth.valid) {
			window.arena.showErrorMessage(null, proposedCartHealth.errors, true);
			return;
		}

		const pdpSection = document.getElementById("pdp");
		const productExtras = pdpSection.getAttribute("data-product-extras");
		const firstImg = pdpSection.querySelector("#product-media-container img");
		const thumbnail = firstImg?.getAttribute("src") || null;

		const steps = [];

		// Vase step (only if not included already)
		const vasesStep = this.giftBuilderVaseStep();
		if (vasesStep) {
			steps.push({
				title: "Add a vase",
				message: "The perfect match for our bouquets",
				type: "addons",
				allowMultiple: false,
				items: vasesStep.items,
				hideStep: vasesStep.hide,
			});
		}

		// Addons step
		if (productExtras) {
			steps.push({
				title: "Send them a gift",
				message: "Make it extra special",
				type: "addons",
				allowMultiple: true,
				items: JSON.parse(productExtras),
			});
		}

		// Card step
		if (this.showCardsFor.includes(this.productType.toLowerCase())) {
			steps.push({
				title: "Choose a card",
				type: "cards",
				message: "Write them a message ",
				allowMultiple: false,
			});
		}

		this.giftBuilder.start(
			{
				mainItem: this.selectedVariant,
				...(this.vaseAddOn && { initialPayload: [this.vaseAddOn] }),
				thumbnail,
				steps,
			},
			async (response) => {
				if (response) {
					this.loadingEl.classList.remove("hidden");
					const loadingTextEl = this.loadingEl.querySelector("p");
					loadingTextEl.innerText = "Getting your order ready…";

					const payload = this.preparePayload(response);
					const cart = await window.arena.addItemsCart(payload);

					// If MOV wasn't reached open the cart
					const minOrderAchieved = window.arena.checkMinOrderValue();
					if (!minOrderAchieved) {
						this.loadingEl.classList.add("hidden");
						window.arena.toggleCartDrawer();
						return;
					}

					// If current cart is not valid, open cart and show errors
					const isValid = this.checkCartHealth();
					if (!isValid.valid) {
						this.loadingEl.classList.add("hidden");
						window.arena.showErrorMessage("Please review your cart", isValid.errors, true);
						return;
					}

					window.addEventListener("beforeunload", () => {
						this.loadingEl.classList.add("hidden");
					});

					// &skip_shop_pay=true
					// It's an unofficial solution to avoid the default use of shop pay at checkout,
					// not supported or announced by shopify, so there is no guarantee that it will always work.
					window.location.href = `${cart.checkoutUrl}&skip_shop_pay=true`;
				} else {
					this.loadingEl.classList.add("hidden");
				}
			}
		);
	}
	// [END] Submit functions

	// [START] updates media list order when selected variants

	handleProductMediaContainer() {
		if (!this.productMediaContainer) return;
		const controllers = document.querySelectorAll(`[aria-controls="${this.productMediaContainer.id}"]`);
		controllers.forEach((controller) => {
			controller.addEventListener("click", this.toggleProductMediaContainer.bind(this));
		});
	}

	toggleProductMediaContainer() {
		const isExpanded = this.productMediaContainer.getAttribute("aria-expanded") === "true";
		this.productMediaContainer.setAttribute("aria-expanded", `${!isExpanded}`);
	}

	updateProductMediaContainer() {
		if (this.numberOFVariants <= 1) return;
		const mediaWrapper = this.productMediaContainer.querySelector("[data-movable]");
		const allMedia = Array.from(mediaWrapper.querySelectorAll("a"));

		allMedia.sort(this.compareMedia.bind(this)).forEach((node) => mediaWrapper.appendChild(node));

		try {
			window.refreshFsLightbox();
		} catch (error) {
			console.error(error);
		}
	}

	compareMedia(a, b) {
		const aImage = a.firstElementChild;
		const bImage = b.firstElementChild;

		// Check if nodes are IMG elements
		if (aImage.nodeName !== "IMG") return 1;
		if (bImage.nodeName !== "IMG") return -1;

		const aVariant = aImage.getAttribute("data-variant-priority");
		const bVariant = bImage.getAttribute("data-variant-priority");
		const aIndex = parseInt(aImage.getAttribute("data-variant-image-index"), 10);
		const bIndex = parseInt(bImage.getAttribute("data-variant-image-index"), 10);

		// Prioritize elements with matching `data-variant-priority`
		if (this.selectedVariant) {
			if (aVariant === this.selectedVariant.merchandiseId && bVariant !== this.selectedVariant.merchandiseId) return -1;
			if (bVariant === this.selectedVariant.merchandiseId && aVariant !== this.selectedVariant.merchandiseId) return 1;
		}

		// If both or neither match, compare by `data-variant-image-index`
		if (aIndex < bIndex) return -1;
		if (aIndex > bIndex) return 1;

		// If all else is equal, maintain current order
		return 0;
	}

	// [END] updates media list order when selected variants

	displayVariantRelatedElements() {
		if (!this.selectedVariant) return;
		// reorder images by variant
		this.updateProductMediaContainer();

		// Show all related elements to selected variant
		this.variantElements.forEach((ele) => {
			const relatedVariant = ele.getAttribute("data-variant");
			const isActiveVariant = relatedVariant === this.selectedVariant.merchandiseId;
			ele.toggleAttribute("hidden", !isActiveVariant || !this.selectedVariant.available);

			// Reset selected items on inactive addOns
			if (!isActiveVariant) {
				const addOns = Array.from(ele.querySelectorAll("button[data-add-on][data-selected]"));
				addOns.forEach((a) => a.removeAttribute("data-selected"));
			}
		});
	}

	handleVaseAddOn() {
		document.querySelectorAll("[data-add-on] img").forEach((btn) => {
			btn.addEventListener("click", ({ currentTarget }) => {
				this.toggleVaseAddOn(currentTarget.closest("button"));
			});
		});
	}

	toggleVaseAddOn(target) {
		if (!target) return;
		const { addOn, price } = target.dataset;
		const isSelected = target.toggleAttribute("data-selected");

		// Unselect other vaseAddOns, only one is allowed per bouquet
		document.querySelectorAll("[data-add-on]").forEach((el) => {
			if (el.dataset.addOn !== addOn) {
				el.removeAttribute("data-selected");
			}
		});

		this.vaseAddOn = isSelected ? { merchandiseId: addOn, quantity: 1, price: parseFloat(price) } : null;
	}
}

// eslint-disable-next-line no-new
const product = new Product();
product.init();
